const apiConfig = {
  titokDev: {
    message_host_key: 'https://vim.mayibat.me',
    movieApiDomain: 'https://vmovie.mayibat.me',
    novelApiDomain: 'https://vnovel.mayibat.me',
    shortApiDomain: 'https://vshort.mayibat.me'
  },
  titok: {
    message_host_key: 'xxxx',
    movieApiDomain: 'https://movie.maybetback.com',
    novelApiDomain: 'xxxx',
    shortApiDomain: 'https://short.maybetback.com'
  },
  '99x': {
    message_host_key: 'xxxx',
    movieApiDomain: 'https://api.99xxxapp1api.com',
    novelApiDomain: 'xxxx',
    shortApiDomain: 'https://api.99xxxapp2api.com'
  }
};

export default apiConfig[SITE_CHANNEL];
